/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

import type { RoleBadgesModule } from '../types'

const securityRoleBadgesModule: RoleBadgesModule<'security'> = {
  allInstancesRoleBadgeTooltipMessages: {
    id: 'role-badges.tooltip.all-security-instances',
    defaultMessage: 'This role applies to all current and future Security projects.',
  },
  specificInstancesRoleBadgeTooltipMessages: {
    id: 'role-badges.tooltip.security',
    defaultMessage:
      'This role applies to {count} Security {count, plural, one {project} other {projects}}.',
  },
  customRoleBadgeTooltipMessages: {
    id: 'custom-role-badges.tooltip.security',
    defaultMessage:
      'Custom roles are applied to {count} Security {count, plural, one {project} other {projects}}.',
  },
  type: 'security',
}

export default securityRoleBadgesModule
